export default __webpack_public_path__ + "static/media/noMedia.93b128c1.svg";